import React, { useEffect, useState } from 'react';
import { useUIStore } from '../store/uiStore';
import { Loader2, CheckCircle2, AlertCircle } from 'lucide-react';

export const SyncIndicator = () => {
  const { syncStatus, syncMessage } = useUIStore();
  const [displayData, setDisplayData] = useState({ status: 'idle', message: '' });

  // Çıkış animasyonunda (fade-out) yazının ve rengin aniden kaybolmaması için son durumu tutuyoruz
  useEffect(() => {
    if (syncStatus !== 'idle') {
      setDisplayData({ status: syncStatus, message: syncMessage });
    }
  }, [syncStatus, syncMessage]);

  const isVisible = syncStatus !== 'idle';
  const isSyncing = displayData.status === 'syncing';
  const isSuccess = displayData.status === 'success';
  const isError = displayData.status === 'error';

  return (
    <div className="fixed bottom-6 right-6 z-[9999] pointer-events-none select-none">
      <div
        className={`
          flex items-center gap-3 px-4 py-2.5 
          rounded-2xl bg-card/95 dark:bg-card/95 backdrop-blur-xl border border-borderColor/80 shadow-[0_10px_35px_rgba(0,0,0,0.15)] text-text
          transition-all duration-300 ease-out transform
          ${isVisible ? 'opacity-100 translate-y-0 scale-100' : 'opacity-0 translate-y-4 scale-95'}
        `}
      >
        <div className="relative flex items-center justify-center w-5 h-5">
          {isSyncing && <Loader2 size={18} className="animate-spin text-primary shrink-0" />}
          {isSuccess && <CheckCircle2 size={18} className="text-emerald-500 shrink-0" />}
          {isError && <AlertCircle size={18} className="text-red-500 shrink-0" />}
        </div>
        
        <div className="flex flex-col min-w-0 pr-1">
          <span className="text-xs font-black tracking-tight text-text flex items-center gap-1.5">
            {displayData.message || (isSyncing ? 'İşlem Yapılıyor' : isSuccess ? 'Tamamlandı' : 'Hata')}
            {isSyncing && <span className="w-1.5 h-1.5 rounded-full bg-primary animate-ping" />}
          </span>
          <span className="text-[10px] font-semibold text-text/50">
            {isSyncing ? 'Lütfen bekleyiniz...' : isSuccess ? 'İşlem başarıyla tamamlandı' : 'Bir sorun oluştu'}
          </span>
        </div>
      </div>
    </div>
  );
};

